import React from "react";

export default function DeleteDoctorModal({ show, onClose, selectedDoctorForDelete, onConfirm }) {
  if (!show || !selectedDoctorForDelete) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px' }}>
        <h2>Delete Doctor</h2>
        <p>Are you sure you want to delete <strong>{selectedDoctorForDelete.display_name || selectedDoctorForDelete.user_name}</strong>?</p>
        <p style={{ color: '#ef4444', fontSize: '14px' }}>This action cannot be undone. All associated patients and sessions will also be deleted.</p>
        <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
          <button
            className="btn"
            onClick={onConfirm}
            style={{ background: '#ef4444', color: '#fff' }}
          >
            Delete
          </button>
          <button
            className="btn"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
